const analyticsEvent = require('./analyticsEvent');
let trackingElements;

const init = () => {
    /* track events from html attributes */
    trackingElements = [...document.querySelectorAll('[data-event][data-event-category][data-event-label]')];

    if (trackingElements.length > 0) {
        trackingElements.forEach(trackingElem => {
            trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
                analyticsEvent(
                    trackingElem.getAttribute('data-event-category'),
                    trackingElem.getAttribute('data-event'),
                    trackingElem.getAttribute('data-event-label')
                );
            });
        });
    }

    // TODO: remove previous listeners
};

init();

module.exports.update = init;



// WEBPACK FOOTER //
// ./js/viscom/viscomjs/analytics/elementsTracking.js